import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import backgroundImg from "../../assets/background.jpg";

import tLineImg from "../../assets/logo/tl-line.png";
import bLineImg from "../../assets/logo/b-line.png";
import hatImg from "../../assets/logo/hat.png";
import mustacheImg from "../../assets/logo/mustache.png";
import moeyImg from "../../assets/logo/moey.png";
import { delay, motion, scale } from "framer-motion";
import Loader from "../general/loader";

class Intro extends Component {
  settings = this.props.Settings;
  language = this.props.Language;

  state = {
    navigate: false,
    isLoading: true, // start with loading
    imagesLoaded: 0,
    totalImages: 6, // background + tLine + bLine + hat + mustache + moey
  };

  handleImageLoad = () => {
    this.setState(
      (prev) => ({ imagesLoaded: prev.imagesLoaded + 1 }),
      () => {
        if (this.state.imagesLoaded === this.state.totalImages) {
          // all images loaded
          this.setState({ isLoading: false });
        }
      }
    );
  };

  componentDidMount() {
    const images = [
      backgroundImg,
      tLineImg,
      bLineImg,
      hatImg,
      mustacheImg,
      moeyImg,
    ];

    let loadedCount = 0;

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedCount++;
        if (loadedCount === images.length) {
          // wait 0.5s before hiding loader
          setTimeout(() => {
            this.setState({ isLoading: false });
          }, 500);
        }
      };
    });
  }

  // componentDidMount() {
  //     setTimeout(() => {
  //         this.setState({ isLoading: false });
  //     }, 2000);
  // }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ navigate: true });
  };

  handleChange = (lang) => {
    this.props.handleLangaugeSubmit(lang);
  };

  handleMenuType = (type) => {
    this.props.setOrderType(type); // updates App.state.orderType
  };

  render() {
    const { navigate, isLoading } = this.state;
    const { selectedLang } = this.state || {};
    const letters = "NORJAN".split("");

    const buttonContainer = {
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.4, // slower stagger between buttons
        },
      },
    };

    const buttonVariants = {
      hidden: { scale: 0.7, opacity: 0 },
      visible: {
        scale: 1,
        opacity: 1,
        transition: {
          duration: 3, // slower animation
          ease: "easeOut", // smooth easing
        },
      },
    };
    const buttonVariants2 = {
      hidden: { scale: 0.7, opacity: 0 },
      visible: {
        scale: 1,
        opacity: 1,
        transition: {
          duration: 1.5, // slower animation
          ease: "easeOut", // smooth easing
        },
      },
    };

    return (
      <>
        {this.state.navigate && <Navigate to="/menu/600" replace={true} />}

        {isLoading ? (
          <motion.div
            key="loader"
            className="loader-container"
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <Loader />
          </motion.div>
        ) : (
          <motion.div
            style={{ overflow: "hidden" }}
            key="content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          >
            <>
              <img
                src={backgroundImg}
                alt=""
                className="introBackground"
                loading="eager"
              />
              <div className="introOverlay" />
              <div className="intro ">
                <div className="head ">
                  {/* <img src={logo} alt="" className="img" /> */}

                  {/* custom logo */}

                  <div className="c-logo">
                    <motion.img
                      src={tLineImg}
                      alt=""
                      className="t-line"
                      loading="eager"
                      initial={{ opacity: 0, clipPath: "inset(0 0 0 100%)" }}
                      animate={{ opacity: 1, clipPath: "inset(0 0 0 0%)" }}
                      transition={{
                        duration: 2,
                        ease: "easeInOut",
                        delay: 0.3,
                      }}
                    />

                    <motion.img
                      src={hatImg}
                      alt=""
                      className="hat"
                      loading="eager"
                      initial={{ opacity: 0, clipPath: "inset(0 0 0 100%)" }}
                      animate={{ opacity: 1, clipPath: "inset(0 0 0 0%)" }}
                      transition={{ duration: 1, ease: "easeInOut", delay: 1 }}
                    />
                    {/* <img src={hatImg} alt="" className="hat" loading="eager" /> */}

                    <p>
                      {letters.map((letter, i) => {
                        if (i === 0 || i === letters.length - 1) {
                          return (
                            <motion.span
                              key={i}
                              initial={{ scale: 0, opacity: 0 }}
                              animate={{ scale: 1, opacity: 1 }}
                              transition={{ duration: 1, delay: 0.2 }}
                            >
                              {letter}
                            </motion.span>
                          );
                        }
                        return (
                          <motion.span
                            key={i}
                            initial={{ opacity: 0, scale: 0 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{
                              duration: 0.4,
                              delay: 2 + i * 0.3,
                            }}
                          >
                            {letter}
                          </motion.span>
                        );
                      })}
                    </p>

                    <motion.img
                      src={mustacheImg}
                      alt=""
                      className="mustache"
                      loading="eager"
                      initial={{
                        opacity: 0,
                        clipPath: "inset(0 100% 0 0)",
                      }}
                      animate={{ opacity: 1, clipPath: "inset(0 0 0 0%)" }}
                      transition={{
                        duration: 0.8,
                        ease: "easeInOut",
                        delay: 2.5, // wait 2.5s before starting
                      }}
                    />

                    <motion.img
                      src={moeyImg}
                      alt=""
                      className="moey"
                      loading="eager"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ duration: 1, ease: "easeInOut", delay: 4 }}
                    />

                    <motion.img
                      src={bLineImg}
                      alt=""
                      className="b-line"
                      loading="eager"
                      initial={{
                        opacity: 0,
                        clipPath: "inset(0 100% 0 0)",
                      }}
                      animate={{ opacity: 1, clipPath: "inset(0 0 0 0%)" }}
                      transition={{
                        duration: 1.5,
                        ease: "easeInOut",
                        delay: 2,
                      }}
                    />
                  </div>

                  {/* end custom logo */}

                  <h3
                    key={selectedLang} // changing key triggers re-render
                    className="ani-fade-in-s"
                  >
                    {selectedLang
                      ? "How do you want to order?"
                      : "Welcome to Norjan"}
                  </h3>
                </div>
                {!selectedLang ? (
                  <form>
                    <motion.div
                      style={{ height: "11rem" }}
                      variants={buttonContainer}
                      initial="hidden"
                      animate="visible"
                    >
                      <motion.button
                        variants={buttonVariants}
                        type="button"
                        onClick={() =>
                          this.setState({ selectedLang: "krd" }, () =>
                            this.handleChange("krd")
                          )
                        }
                      >
                        کوردی
                      </motion.button>

                      <motion.button
                        variants={buttonVariants}
                        type="button"
                        onClick={() =>
                          this.setState({ selectedLang: "ar" }, () =>
                            this.handleChange("ar")
                          )
                        }
                      >
                        العربية
                      </motion.button>

                      <motion.button
                        variants={buttonVariants}
                        type="button"
                        className="introEnglishBtn"
                        onClick={() =>
                          this.setState({ selectedLang: "en" }, () =>
                            this.handleChange("en")
                          )
                        }
                      >
                        English
                      </motion.button>
                    </motion.div>
                  </form>
                ) : (
                  <motion.div
                    variants={buttonContainer}
                    initial="hidden"
                    animate="visible"
                    style={{ height: "11rem", marginBottom: "3.125rem" }}
                  >
                    <motion.button
                      variants={buttonVariants2}
                      className=""
                      type="button"
                      onClick={() => {
                        this.setState({ navigate: true });
                        this.handleMenuType(0);
                      }}
                    >
                      {this.props.Language === "en"
                        ? "Dine-in"
                        : this.props.Language === "ar"
                        ? "داخل المطعم"
                        : "ل ژوور "}
                    </motion.button>
                    <motion.button
                      variants={buttonVariants2}
                      className=""
                      type="button"
                      onClick={() => {
                        this.setState({ navigate: true });
                        this.handleMenuType(1);
                      }}
                    >
                      {this.props.Language === "en"
                        ? "Take Away"
                        : this.props.Language === "ar"
                        ? "سفري"
                        : " د گەل خو ببە"}
                    </motion.button>
                  </motion.div>
                )}

                <div className="intro-bottom">
                  <div className="social ani-fade-in-s">
                    {this.settings.facebook && (
                      <a href={this.settings.facebook} target="_blank">
                        {/* facebook svg */}
                        <svg
                          width="17"
                          height="29"
                          viewBox="0 0 17 29"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16 1H11.9091C10.1008 1 8.36657 1.71116 7.08791 2.97703C5.80925 4.2429 5.09091 5.95979 5.09091 7.75V11.8H1V17.2H5.09091V28H10.5455V17.2H14.6364L16 11.8H10.5455V7.75C10.5455 7.39196 10.6891 7.04858 10.9449 6.79541C11.2006 6.54223 11.5474 6.4 11.9091 6.4H16V1Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </a>
                    )}

                    {this.settings.instgram && (
                      <a href={this.settings.instgram} target="_blank">
                        {/* instagram svg */}
                        <svg
                          width="29"
                          height="29"
                          viewBox="0 0 29 29"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21.925 7.075H21.9385M7.75 1H21.25C24.9779 1 28 4.02208 28 7.75V21.25C28 24.9779 24.9779 28 21.25 28H7.75C4.02208 28 1 24.9779 1 21.25V7.75C1 4.02208 4.02208 1 7.75 1ZM19.9 13.6495C20.0666 14.773 19.8747 15.9205 19.3516 16.9287C18.8285 17.9368 18.0007 18.7544 16.9862 19.2651C15.9716 19.7757 14.8219 19.9535 13.7005 19.773C12.5791 19.5926 11.5432 19.0631 10.74 18.26C9.93689 17.4568 9.40744 16.4209 9.22699 15.2995C9.04654 14.1781 9.22429 13.0284 9.73494 12.0138C10.2456 10.9993 11.0632 10.1716 12.0713 9.64843C13.0795 9.1253 14.227 8.93339 15.3505 9.1C16.4965 9.26994 17.5575 9.80398 18.3768 10.6232C19.196 11.4425 19.7301 12.5035 19.9 13.6495Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </a>
                    )}

                    {this.settings.snapchat && (
                      <a href={this.settings.snapchat} target="_blank">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="40"
                          viewBox="0 0 640 640"
                        >
                          <path
                            fill="#ffffff"
                            d="M561.1 430.6C557.7 421.4 551.3 416.5 544 412.4C542.6 411.6 541.4 410.9 540.3 410.5C538.1 409.4 535.9 408.3 533.7 407.1C510.9 395 493.1 379.8 480.7 361.7C477.2 356.6 474.1 351.2 471.6 345.6C470.5 342.6 470.6 340.9 471.4 339.3C472.2 338.1 473.1 337.1 474.3 336.3C478.2 333.7 482.3 331.1 485 329.3C489.9 326.1 493.8 323.6 496.2 321.9C505.6 315.4 512.1 308.4 516.2 300.6C519.1 295.2 520.7 289.3 521.1 283.2C521.5 277.1 520.5 271 518.3 265.4C512.1 249.1 496.7 239 478 239C474.1 239 470.1 239.4 466.3 240.2C465.3 240.4 464.2 240.7 463.2 240.9C463.4 229.7 463.1 218 462.1 206.4C458.6 165.6 444.3 144.3 429.4 127.2C419.9 116.5 408.7 107.5 396.2 100.5C373.6 87.6 348 81.1 320.1 81.1C292.2 81.1 266.7 87.6 244.1 100.5C231.6 107.5 220.4 116.6 210.8 127.3C195.9 144.3 181.6 165.7 178.1 206.5C177.1 218.1 176.9 229.9 177 241C176 240.7 175 240.5 173.9 240.3C170 239.5 166.1 239.1 162.2 239.1C143.5 239.1 128.1 249.2 121.9 265.5C119.7 271.2 118.7 277.3 119.1 283.3C119.5 289.3 121.1 295.3 124 300.7C128.1 308.5 134.7 315.4 144 322C146.5 323.7 150.4 326.2 155.2 329.4C157.8 331.1 161.7 333.6 165.5 336.1C166.8 337 167.9 338.1 168.8 339.4C169.6 341 169.6 342.8 168.4 346C165.9 351.5 162.9 356.8 159.5 361.8C147.4 379.5 130.1 394.4 108.1 406.4C96.4 412.6 84.2 416.7 79.1 430.7C75.2 441.2 77.8 453.2 87.6 463.3C91.2 467.1 95.4 470.2 100 472.7C109.6 478 119.8 482 130.3 484.8C132.5 485.4 134.6 486.3 136.4 487.5C140 490.6 139.5 495.4 144.2 502.3C146.6 505.9 149.6 509 153.2 511.4C163.2 518.3 174.5 518.8 186.4 519.2C197.2 519.6 209.4 520.1 223.3 524.7C229.1 526.6 235.1 530.3 242 534.6C258.7 544.9 281.6 558.9 319.8 558.9C358 558.9 381.1 544.8 397.9 534.5C404.8 530.3 410.8 526.6 416.4 524.7C430.3 520.1 442.6 519.6 453.3 519.2C465.2 518.7 476.5 518.3 486.5 511.4C490.7 508.5 494.2 504.7 496.7 500.2C500.1 494.4 500.1 490.3 503.3 487.4C505.1 486.2 507 485.3 509.1 484.8C519.8 482 530.1 477.9 539.9 472.6C544.8 470 549.2 466.5 552.9 462.4L553 462.2C562.2 452.3 564.5 440.7 560.8 430.4zM527.1 448.9C506.4 460.4 492.6 459.1 481.8 466C472.7 471.9 478.1 484.5 471.5 489.1C463.4 494.7 439.3 488.7 408.3 499C382.7 507.5 366.3 531.8 320.3 531.8C274.3 531.8 258.3 507.5 232.2 498.9C201.2 488.6 177.1 494.7 169 489C162.4 484.4 167.8 471.8 158.7 465.9C148 459 134.2 460.2 113.4 448.8C100.2 441.5 107.7 437 112.1 434.9C187.2 398.5 199.2 342.3 199.8 338.2C200.4 333.2 201.2 329.2 195.6 324.1C190.2 319.1 166.4 304.4 159.8 299.8C148.9 292.2 144.1 284.5 147.6 275.2C150.1 268.7 156.1 266.3 162.5 266.3C164.5 266.3 166.5 266.5 168.5 267C180.5 269.6 192.2 275.6 198.9 277.2C199.7 277.4 200.5 277.5 201.4 277.5C205 277.5 206.3 275.7 206 271.6C205.2 258.5 203.4 232.9 205.4 209C208.2 176.1 218.8 159.8 231.4 145.4C237.5 138.5 265.9 108.4 320.3 108.4C374.7 108.4 403 138.2 409 145.1C421.6 159.5 432.2 175.8 435 208.7C437.1 232.6 435.3 258.2 434.4 271.3C434.1 275.6 435.4 277.2 439 277.2C439.8 277.2 440.7 277.1 441.5 276.9C448.2 275.3 459.9 269.3 471.9 266.7C473.9 266.3 475.9 266 477.9 266C484.3 266 490.3 268.5 492.8 274.9C496.3 284.3 491.6 291.9 480.6 299.5C474 304.1 450.2 318.8 444.8 323.8C439.2 328.9 440 332.9 440.6 338C441.1 342.2 453.1 398.4 528.3 434.7C532.7 436.9 540.2 441.4 527 448.8z"
                          />
                        </svg>
                      </a>
                    )}

                    {this.settings.titok && (
                      <a href={this.settings.titok} target="_blank">
                        {/* tiktok svg */}
                        <svg
                          width="27"
                          viewBox="0 0 16 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.8962 3.87151C13.0462 3.87151 11.5411 2.36638 11.5411 0.516353C11.5411 0.231188 11.3099 0 11.0248 0H8.25937C7.97421 0 7.74302 0.231188 7.74302 0.516353V11.8543C7.74302 12.9419 6.85816 13.8268 5.77052 13.8268C4.68291 13.8268 3.79808 12.9419 3.79808 11.8543C3.79808 10.7667 4.68291 9.88182 5.77052 9.88182C6.05568 9.88182 6.28687 9.65063 6.28687 9.36547V6.60009C6.28687 6.31493 6.05568 6.08374 5.77052 6.08374C2.58865 6.08374 0 8.67242 0 11.8543C3.44235e-05 15.0362 2.58865 17.6248 5.77055 17.6248C8.95246 17.6248 11.5411 15.0362 11.5411 11.8543V6.83572C12.5689 7.38357 13.7123 7.66959 14.8962 7.66959C15.1814 7.66959 15.4126 7.43841 15.4126 7.15324V4.38786C15.4125 4.1027 15.1814 3.87151 14.8962 3.87151ZM14.3798 6.61551C13.2775 6.52384 12.2307 6.13875 11.3263 5.48811C11.1691 5.37499 10.9617 5.3594 10.7893 5.44773C10.6169 5.53609 10.5084 5.71351 10.5084 5.90725V11.8543C10.5084 14.4668 8.38299 16.5921 5.77052 16.5921C3.15808 16.5921 1.03271 14.4668 1.03271 11.8543C1.03271 9.41628 2.88369 7.40247 5.25417 7.1444V8.89352C3.84222 9.13896 2.76538 10.3733 2.76538 11.8543C2.76538 13.5114 4.11347 14.8595 5.77052 14.8595C7.4276 14.8595 8.77573 13.5114 8.77573 11.8543V1.03271H10.5386C10.775 3.04028 12.3723 4.63757 14.3798 4.87399L14.3798 6.61551Z"
                            fill="#ffffffff"
                          />
                        </svg>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </>
          </motion.div>
        )}
      </>
    );
  }
}

export default Intro;
